import { phpApi } from "../default";

export const generalPhpApiDownloadFileRequest = (url) => {
  return phpApi.get(url, { responseType: "blob" });
};